export class ValidationResult {
  private errors: ValidationError[];
  private _hasNOTIFICATION: boolean;
  private _hasWARNING: boolean;
  private _hasERROR: boolean;

  constructor(errors: ValidationError[]) {
    this.errors = errors;
    this._hasNOTIFICATION = false;
    this._hasWARNING = false;
    this._hasERROR = false;
    errors.forEach((error) => {
      this._hasNOTIFICATION = this._hasNOTIFICATION || error.severity === ValidationSeverity.NOTIFICATION;
      this._hasWARNING = this._hasWARNING || error.severity === ValidationSeverity.WARNING;
      this._hasERROR = this._hasERROR || error.severity === ValidationSeverity.ERROR;
    });
  }

  public getErrors(): ValidationError[] {
    return this.errors;
  }

  public hasNOTIFICATION() {
    return this._hasNOTIFICATION;
  }

  public hasWARNING() {
    return this._hasWARNING;
  }

  public hasERROR() {
    return this._hasERROR;
  }
}

export class ValidationError {
  public path: string;
  public code: string;
  public severity: ValidationSeverity;
  public message: string;
}

export enum ValidationSeverity {
  NOTIFICATION,
  WARNING,
  ERROR,
}
